export const formats = ["bold", "italic", "underline", "strike"];
export const modules = {
	toolbar: [["bold", "italic", "underline", "strike"]],
};
